/**
 * Returns object with actions from shared redux store
 * See the list in asg-framework/components/shared/index.jsx
 */
export const useAsgActions = () => {
    return AsgSharedComponents.state.actions;
};
